import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { DomSanitizer } from '@angular/platform-browser';
import * as fromStore from '../../../store';
import { Store } from '@ngrx/store';
import scrollLock from 'scroll-lock';
import { SidebarService } from '@ibe/services/ui';
import * as ModalActions from '@ibe/store/actions/modal.actions';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { BookedTrip } from '@ibe/models';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { TRIP_TYPE_MULTICITY_CODE, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_ROUND_TRIP_CODE } from '@ibe.config';
import { INDRADateService } from '@ibe.services/date.indra.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-booking-modal',
  templateUrl: './booking-modal.component.html',
  styleUrls: ['./booking-modal.component.scss']
})
export class BookingModalComponent extends AbstractModalContentComponent implements OnDestroy, OnInit {

	htmlElement = document.getElementsByTagName('html');

	// Corp
	isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	isCorporate: boolean;
	isAlive: boolean = true;

  	booked_trip: INDRABookedTripDetails;

	hideClose: boolean = false;
	destinationForHotel;
	destinationCity;
	hotelBookingDates;
	language;

	constructor(
		protected modalService: ModalService,
		private route: ActivatedRoute,
		private router: Router,
		private sanitizer: DomSanitizer,
		protected sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private bfmStorage: INDRABFMDataStorageService,
		private dateService: INDRADateService,
		private elementRef: ElementRef
	) {
		super(modalService);
		this.store.dispatch(new ModalActions.PutShowCloseAction(false));

		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
			});

		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.language = sessionStorage.getItem('language');
	}

	ngOnInit() {
		this.INDRA_generateHotelEmergingWindow();
	}

	INDRA_generateHotelEmergingWindow() {
		// https://aff.bstatic.com/static/affiliate_base/js/booking_sp_widget.js?checkin=2021-09-10&checkout=2021-09-17&iata_orr=1&iata=CDG'

		const hotelPopup = document.createElement('script');
		hotelPopup.type = 'text/javascript';	
		hotelPopup.id = 'sp_widget';
		hotelPopup.setAttribute('data-hash', '_b2fae705c611');
		hotelPopup.setAttribute('data-container', 'c_container');
		hotelPopup.setAttribute('data-size', '480x280'); 
		hotelPopup.setAttribute('data-tpncy', 'false');
		
		const hotelBooking = this.INDRA_getCheckInOutDates();
		let checkIn = hotelBooking.checkIn;
		let checkOut = hotelBooking.checkOut;
		let destination = this.destinationForHotel;
		let iataOrr = '1';
		hotelPopup.src = `//aff.bstatic.com/static/affiliate_base/js/booking_sp_widget.js?checkin=${checkIn}&checkout=${checkOut}&iata_orr=${iataOrr}&iata=${destination}&lang=${this.language}`;
		
		this.elementRef.nativeElement.appendChild(hotelPopup);	
	}

		
	ngOnDestroy() {
		this.isAlive = false;
	}

	closeModal() {
		if (this.htmlElement[0].classList.contains('no-scroll')) {
			if (this.router.url.indexOf('sidebar') < 0) {
				this.htmlElement[0].classList.remove('no-scroll');
				scrollLock.show();
			}
		}
		this.modalService.close();
	}

	INDRA_getCheckInOutDates() {
		let hotelBookingDates = {
			checkIn: '',
			checkOut: '' 
		}

		if (this.booked_trip.data.fare) {
			switch (this.booked_trip.data.fare.tripType) {
				case TRIP_TYPE_ROUND_TRIP_CODE:
					if (this.booked_trip.data.fare && !_.isEmpty(this.booked_trip.data.fare.listOutbound) && !_.isEmpty(this.booked_trip.data.fare.listInbound)) {
						const checkIn = this.booked_trip.data.fare.listOutbound[0].listSegment[this.booked_trip.data.fare.listOutbound[0].listSegment.length - 1].arrivalDate.toString();
						const checkOut = this.booked_trip.data.fare.listInbound[0].firstSegment.departureDate;
						hotelBookingDates.checkIn = this.dateService.INDRA_formatDate(checkIn, 'YYYY-MM-DD');
						hotelBookingDates.checkOut = this.dateService.INDRA_formatDate(checkOut, 'YYYY-MM-DD');

						this.INDRA_getDestination(this.booked_trip.data.fare.tripType, this.booked_trip.data.fare.listOutbound);
					}
					break;
				case TRIP_TYPE_ONE_WAY_CODE:
					if (this.booked_trip.data.fare && !_.isEmpty(this.booked_trip.data.fare.listOutbound)) {
						const checkIn = this.booked_trip.data.fare.listOutbound[0].listSegment[this.booked_trip.data.fare.listOutbound[0].listSegment.length - 1].arrivalDate.toString();
						hotelBookingDates.checkOut = this.dateService.INDRA_add(checkIn, 1, 'days').format('YYYY-MM-DD').toString();
						hotelBookingDates.checkIn = this.dateService.INDRA_formatDate(checkIn, 'YYYY-MM-DD');

						this.INDRA_getDestination(this.booked_trip.data.fare.tripType, this.booked_trip.data.fare.listOutbound);
					}
					break;
				case TRIP_TYPE_MULTICITY_CODE:
					if (this.booked_trip.data.fare && !_.isEmpty(this.booked_trip.data.fare.listOutbound)) {
						const secondTripMC = this.booked_trip.data.fare.listOutbound[1].listSegment;
						// this.destinationForHotel = secondTripMC[secondTripMC.length - 1].arrivalAirport;
						
						const checkIn = secondTripMC[secondTripMC.length - 1].arrivalDate.toString();
						hotelBookingDates.checkOut = this.dateService.INDRA_add(checkIn, 1, 'days').format('YYYY-MM-DD').toString();
						hotelBookingDates.checkIn = this.dateService.INDRA_formatDate(checkIn, 'YYYY-MM-DD');

						this.INDRA_getDestination(this.booked_trip.data.fare.tripType, this.booked_trip.data.fare.listOutbound);
					}
					break;
			}
		}	

		return hotelBookingDates;
	}

	INDRA_getDestination(tripType, listOutbound) {
		const locations = this.booked_trip.translate.locations;
		if (tripType != TRIP_TYPE_MULTICITY_CODE) {
			const lastOutbound = listOutbound.length - 1;
			const segments = listOutbound[lastOutbound].listSegment;
			const destinationCode = segments[segments.length - 1].arrivalAirport;
			const destinationLocation = locations[destinationCode] ? locations[destinationCode] : null;

			this.destinationForHotel = destinationLocation.code;
			this.destinationCity = destinationLocation.city;
		} else {
			// For multi-city journeys, display 2nd segment/Trip destination 
			const secondTripMC = listOutbound[1].listSegment;
			this.destinationForHotel = secondTripMC[secondTripMC.length - 1].arrivalAirport;
			this.destinationCity = locations[this.destinationForHotel].city;
		}
	}
}